module.exports = __webpack_public_path__ + "static/media/shield.8f147c6f.svg";